import type { AuthEnvironment, AuthMode } from '../auth/types';

export type DeploymentEnvironment = AuthEnvironment['environment'];

export interface PublicEnvironmentValues {
  readonly VITE_APP_ENV?: string;
  readonly VITE_AUTH_MODE?: string;
}

export function resolveEnvironment(values: PublicEnvironmentValues): AuthEnvironment {
  const environment = values.VITE_APP_ENV;
  const authMode = values.VITE_AUTH_MODE;
  if (environment !== 'dev' && environment !== 'uat' && environment !== 'prod') {
    throw new Error('VITE_APP_ENV must be dev, uat, or prod');
  }
  if (authMode !== 'mock' && authMode !== 'cognito') {
    throw new Error('VITE_AUTH_MODE must be mock or cognito');
  }
  if (environment !== 'dev' && authMode === 'mock') {
    throw new Error('Mock Auth is DEV-only');
  }

  return { environment, authMode: authMode as AuthMode };
}

export const publicEnvironment = resolveEnvironment({
  VITE_APP_ENV: import.meta.env.VITE_APP_ENV,
  VITE_AUTH_MODE: import.meta.env.VITE_AUTH_MODE,
});
